<nav class="navbar">
  <div class="container-fluid">
    <div class="navbar-header">
      <a class="navbar-brand" [routerLink]="[_auth.user.getHomeUrl()]">
        <img class="logo" src="assets/images/left-menu/logo-bf-vertical.png" />
        <span class="header-bar"></span>
      </a>
      <div class="header-title">
        <h5>{{ _auth.user.getUserData().companyName }}</h5>
        <h6>{{ _auth.user.getUserData().idNumber }}</h6>
      </div>
    </div>
    <div class="navbar-right">
      <div id="lastConect" class="navbar-left last-connection text-center">
        <span class="pt-5 txt-connection">
          Última conexión 
          {{ _auth.user.getUserData().lastAccess | date:'dd/MM/yyyy' }} 
          a las {{ _auth.user.getUserData().lastAccess | date:'shortTime' }}
        </span>
      </div>
      <button class="button-menu button-logout btn btn-circle" (click)="logout()" alt="Cerrar sesión">
        <img src="assets/images/left-menu/icn-logout-right.png" />
      </button>
    </div>
  </div>
</nav>
